// src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ContactPage from './pages/ContactPage'; // <<< 1. IMPORT THE NEW PAGE

// This line is the source of the error.
// It tells React: "Look inside the CURRENT folder (src), find a folder named 'pages', and then find a file named 'HomePage' inside it."
import HomePage from './pages/ HomePage'; 
import ProjectsPage from './pages/ProjectsPage';
import AboutPage from './pages/AboutPage'; // <<< 1. IMPORT THE NEW PAGE
import ServicesPage from './pages/ServicesPage'; // <<< 1. IMPORT THE NEW PAGE
import ProcessPage from './pages/ProcessPage'; // <<< 1. IMPORT THE NEW PAGE
import ScrollToTop from './components/ScrollToTop'; // <<< 1. IMPORT THE COMPONENT
import WhyChooseUsPage from './pages/WhyChooseUsPage'; // <<< 1. IMPORT THE NEW PAGE
import GalleryPage from './pages/GalleryPage'; // <<< 1. IMPORT THE NEW PAGE

function App() {
  return (
    <Router>
            <ScrollToTop /> {/* <<< 2. ADD IT HERE */}

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/projects" element={<ProjectsPage />} />
                <Route path="/about" element={<AboutPage />} /> {/* <<< 2. ADD THE NEW ROUTE */}
        <Route path="/services" element={<ServicesPage />} /> {/* <<< 2. ADD THE NEW ROUTE */}
        <Route path="/process" element={<ProcessPage />} /> {/* <<< 2. ADD THE NEW ROUTE */}
        <Route path="/why-choose-us" element={<WhyChooseUsPage />} /> {/* <<< 2. ADD THE NEW ROUTE */}
        <Route path="/contact" element={<ContactPage />} /> {/* <<< 2. ADD THE NEW ROUTE */}
        <Route path="/gallery" element={<GalleryPage />} /> {/* <<< 2. ADD THE NEW ROUTE */}

      </Routes>
    </Router>
  );
}

export default App;